export default {
  list: null,
  meta: null,
  loading: null,
  searchClanVariant: null,

  clan: {},
  place: {},
};
